/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_IngredientsInputs */

const vi_fertilizer_ingredients = /** @type {(inputs: Fertilizer_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành phần`)
};

/**

* @param {Fertilizer_IngredientsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_ingredients = /** @type {((inputs?: Fertilizer_IngredientsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_IngredientsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_ingredients(inputs)
});